import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { accountTicketsOverviewQuery } from './queries';

export const useAccountTicketsOverview = (
  config: Partial<ReturnType<typeof accountTicketsOverviewQuery>> = {},
) => {
  const { isSignedIn } = useAuth();

  const { locale } = useLocale();
  const query = useQuery({
    ...accountTicketsOverviewQuery({ locale }),
    retry: false,
    staleTime: StaleTime.ONE_HOUR,
    ...config,
    enabled: !!isSignedIn && config.enabled,
  });

  return {
    pastEvents: query.data?.pastEvents ?? [],
    upcomingEvents: query.data?.upcomingEvents ?? [],
    status: query.status,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
